import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from './shared/contexts/AuthContext';
import { getContexto } from './shared/utils/contexto';

// Lazy — quem já tem sessão nunca a vê, não vale a pena pô-la no bundle inicial.
const Landing = lazy(() => import('./features/landing/Landing'))

export const App = () => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    // A raiz do www (e do domínio raiz) é a landing page pública; nos
    // subdomínios da app (cond/prop) continua a ir directa para o login.
    return getContexto() === 'NEUTRO' ? <Landing /> : <Navigate to="/login" replace />
  }

  // Quem está ligado a mais do que um estate tem um portefólio — manda-o
  // para o selector em vez de entrar logo num só.
  if ((user?.estateIds?.length ?? 0) > 1) {
    return <Navigate to="/properties" replace />
  }

  return <Navigate to={user?.estateId ? `/properties/${user.estateId}` : '/properties'} replace />
}
